import { getConfig } from "../config";

/**
 * The CORP support auto-tenant behaviour is opt-in, gated by a Key Vault secret.
 *
 * The secret `SupportAutoTenantEnabled` (value "Y" to enable) flows into
 * `window.config.supportAutoTenantEnabled` via the same path as the Analytics flag:
 * `config.aspx` (server env var `SUPPORT_AUTO_TENANT_ENABLED`) when deployed somewhere
 * that executes .aspx, or the `__SUPPORT_AUTO_TENANT__` token the pipeline injects into
 * index.html at build time (the real path on Azure Static Web Apps).
 *
 * The Function App reads the SAME secret through an app setting named
 * `SupportAutoTenantEnabled` (see Security/SupportTenantPolicy.cs), so the client and the
 * backend turn on and off together. Should the two ever drift, the backend wins: it
 * answers 403 and the client falls back to logging the user into their own tenant.
 *
 * Only the exact value "Y" (case-insensitive, trimmed) turns it on. Anything else —
 * empty, "N", or the unreplaced `__SUPPORT_AUTO_TENANT__` token in local dev — leaves
 * today's behaviour untouched (CORP users log into CORP). Read lazily via getConfig() so
 * it always reflects the live window.config and stays mockable in tests.
 */
export const isSupportAutoTenantEnabled = (): boolean =>
  (getConfig()?.supportAutoTenantEnabled ?? "").trim().toUpperCase() === "Y";
